import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { InputRenderer } from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length } from "src/shared/forms/validations/Length";
import TextValidation from "src/shared/forms/validations/TextValidation";
import type { ValidationHandler } from "src/shared/forms/validations/ValidationHandler";

export interface IContactTitleInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export default ({
  inputID,
  label = <FormattedMessage id="contacts.title" />,
  validationDisabled = false,
  ...rest
}: IContactTitleInputProps) => {
  const validations: ValidationHandler[] | undefined = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }
    return [
      length(3, 64),
      TextValidation(<FormattedMessage id="contacts.title.invalid" />),
    ];
  }, [validationDisabled]);
  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
